import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_SERVER_URL,
  timeout: 30000,
})

const callApi = async <T>(
  apiConfig: APIConfig,
  responseInterceptor = (response: AxiosResponse<T>) => response.data
): Promise<T> => {
  const mandatoryHeaders = {
    'Content-Type': 'application/json',
    Authorization: '',
  }
  const { headers, endpoint, considerMandatoryHeaders = true } = apiConfig

  const requestHeaders = {
    ...(considerMandatoryHeaders && mandatoryHeaders),
    ...headers,
  }

  const config: AxiosRequestConfig = {
    ...apiConfig,
    headers: requestHeaders,
    ...(endpoint && { url: endpoint }),
  }

  return axiosInstance
    .request(config)
    .then(responseInterceptor)
    .catch((error) => {
      throw error
    })
}

export default callApi
